import React from 'react'
import { AlarmStatus } from '../../../../../@types/alarmStatus'
import toolbarStyles from '../../../../../components/OrderServiceChecklist/OrderServiceToolbar/orderServiceToolbar.module.css'

const STATUS_TABS: Array<{value: number, label: string, countKey: keyof AlarmStatus, color: string}> = [
  { value: -1, label: 'Total', countKey: 'total', color: 'dark' },
  { value: 0, label: 'Normais', countKey: 'normalNum', color: 'success' },
  { value: 2, label: 'Em alerta', countKey: 'attention', color: 'warning' },
  { value: 1, label: 'Offline', countKey: 'offlineNum', color: 'danger' },
  { value: 3, label: 'Informativo', countKey: 'info', color: 'info' },
  { value: -2, label: 'Com Alarme', countKey: 'alertCount', color: 'primary' },
]

type Props = {
  alarmStatus: AlarmStatus
  filterAlarms: number
  onChange: (value: number) => void
}

const PlantStatusTabs: React.FC<Props> = ({alarmStatus, filterAlarms, onChange}) => {
  return (
    <div className={toolbarStyles.statusTabs} role='tablist'>
      {STATUS_TABS.map((tab) => {
        const count = alarmStatus[tab.countKey] || 0
        const isSelectable = tab.value === -1 || count > 0
        const isActive = filterAlarms === tab.value
        return (
          <button
            key={tab.value}
            type='button'
            role='tab'
            aria-selected={isActive}
            disabled={!isSelectable}
            className={`btn btn-sm ${toolbarStyles.statusTab} ${
              isActive ? `btn-${tab.color} ${toolbarStyles.statusTabActive}` : 'btn-color-gray-700 btn-active-light'
            }`}
            onClick={() => onChange(tab.value)}
          >
            <span>{tab.label}</span>
            <span className={`badge ${isActive ? toolbarStyles.statusCountActive : `badge-light-${tab.color}`} ${toolbarStyles.statusCount}`}>
              {count}
            </span>
          </button>
        )
      })}
    </div>
  )
}

export {PlantStatusTabs}
